import axios from 'axios'
import { i18n } from '../../../plugins/i18n'

export const companiesProductCategories = {
  namespaced: true,
  state: {
    data: null,
    loading: false,
  },
  mutations: {
    readProductCategoriesSuccess(state, payload) {
      state.data = payload.data.map(v => {
        return { id: v.id, name: v.attributes.name, canDelete: v.attributes.can_delete }
      })
      state.loading = false
    },
    deleteProductCategorySuccess(state, ProductCategoryId) {
      state.data = state.data.filter(function(value){
        return value.id !== ProductCategoryId
      })
      state.loading = false
    },
    prepareConnect(state) {
      state.loading = true
    },
    stopLoading(state) {
      state.loading = false
    }
  },
  actions: {
    readProductCategories({ commit, rootState }) {
      commit('prepareConnect')
      return axios
        .get('/api/companies/' + rootState.route.params.company_uuid + '/product_categories.json')
        .then(res => {
          commit('readProductCategoriesSuccess', res.data)
        })
        .catch(err => {
          commit('stopLoading')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
        })
    },
    deleteProductCategory({ commit, rootState }, productCategoryId ) {
      commit('prepareConnect')
      axios
        .delete('/api/companies/' + rootState.route.params.company_uuid + '/product_categories/' + productCategoryId + '.json')
        .then(() => {
          commit('deleteProductCategorySuccess', productCategoryId)
          commit('flash/updateFlash', { type: 'notice', message: i18n.t('messages.deleted', { value: i18n.t('models.productCategory.modelName') }) }, { root: true })
        })
        .catch(err => {
          commit('stopLoading')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
        })
    },
  }
}
